import React from "react";

import HeroSection from "../utilities/HeroSection.jsx";
import ObjectiveSection from "./ObjectiveSection.jsx";
import PublishSection from "./PublishSection.jsx";
import VideoBookSection from "./VideoBookSection.jsx";
import Featured from "./Featured.jsx";
import TrendingandGallery from "./TrendingandGallery.jsx";
import HomeInfo from "./HomeInfo.jsx";
import Videos from "./Videos.jsx";


function Home({ banners, isLoading, error }) {
  const homeBanners = banners ? banners["home page"] : [];

  return (
    <>
      <HeroSection banners={homeBanners} isLoading={isLoading} error={error} />
      <HomeInfo />
      <VideoBookSection />
      <PublishSection />
      <ObjectiveSection />
      <Featured />
      <Videos />
      <TrendingandGallery />
    </>
  );
}

export default Home;
